import { SHOW_SIDEBAR_MENU_CHANGED } from "../actions/dashboardUIActions";

const initialState = {
    showSidebarMenu: false
};

export default function dashboardUI(state = initialState, action) {
    switch (action.type) {
        case SHOW_SIDEBAR_MENU_CHANGED:
            return {
                ...state,
                showSidebarMenu: action.payload
            };
        default:
            return state;
    }
}
